import React from "react";
import { Stack, Typography } from '@curves/ui-base';

import { Link } from "react-router-dom";
import { CYCLE_PURCHASE_DETAIL_MAIN_ROUTER_URL } from "@Router/routerPath";
import { OverflowMenu } from "@Local/Components";
import { isEmpty } from "@Util/utils";
// 循環訂單總覽列表
export const getCyclePurchaseCancelOverviewRowLabel = (pushToCyclePurchaseDetail, overviewData, dialogRef, refresh, cancelDialogRef) => {
	return [
		{
			cellKey: "cycleOrderNo",
			headerLabel: "循環訂單編號",
			width: "15",
			align: "left",
			formatCell: (cellValue, rowData) => {
				return (
					<Stack direction={"column"}>
						<Link to={CYCLE_PURCHASE_DETAIL_MAIN_ROUTER_URL(rowData.cycleOrderID)?.concat(`?from=cancel-overview`)}>
							{cellValue || "-"}
						</Link>
					</Stack>
				);
			},
		},
		{
			cellKey: "clubName",
			headerLabel: "所屬店鋪",
			width: "15",
			formatCell: (cellValue, rowData) => {
				return <Typography>{rowData?.clubName || "-"}</Typography>;
			},
		},
		{
			cellKey: "memberNo",
			headerLabel: "會員編號",
			width: "15",
			formatCell: (cellValue, rowData) => {
				return <Typography>{rowData?.memberNo || "-"}</Typography>;
			},
		},
		{
			cellKey: "memberName",
			headerLabel: "會員姓名",
			width: "",
			formatCell: (cellValue, rowData) => {
				return <Typography>{rowData?.memberName || "-"}</Typography>;
			},
		},
		{
			cellKey: "cycleOrderID",
			headerLabel: "",
			align: "right",
			isIcon: true,
			formatCell: (cellValue, rowData) => {
				const menuData = [
					{
						text: "循環訂單收費明細",
						onClick: () => {
							if (rowData?.cycleOrderID && dialogRef?.current) {
								dialogRef.current.openDetailsDialog(
									{
										cycleOrderID: rowData?.cycleOrderID,
										memberID: rowData?.memberID,
										clubName: rowData?.clubName,
										memberName: rowData?.memberName,
										cellPhone: rowData?.cellPhone,
										memberNo: rowData?.memberNo,
									},
									refresh
								);
							}
						},
					},
					{
						text: "退訂主單",
						onClick: () => {
							if (rowData?.cycleOrderID && cancelDialogRef?.current) {
								cancelDialogRef.current.openCyclePurchaseCancelDialog(
									{ cycleOrderID: rowData?.cycleOrderID },
									refresh
								);
							}
						},
					},
				];
				return <OverflowMenu menuData={menuData} enabled={!isEmpty(menuData)} />;
			},
		},
	];
};
